// Statistics data structure for tracking game performance

export interface GameStatistics {
    gamesPlayed: number
    gamesWon: number
    bestTime: number | null // in milliseconds, null if no wins yet
    totalPlayTime: number // total time spent playing in milliseconds
    currentStreak: number // consecutive wins
    longestStreak: number // best streak ever
    averageWinTime: number | null // average time for won games in milliseconds
}

export const defaultStatistics: GameStatistics = {
    gamesPlayed: 0,
    gamesWon: 0,
    bestTime: null,
    totalPlayTime: 0,
    currentStreak: 0,
    longestStreak: 0,
    averageWinTime: null,
}
